import { PRODUCT_TYPES } from '@/constants'

export function isProductInSet(productTypeId: number | null | undefined): boolean {
    return productTypeId != null && PRODUCT_TYPES.PRODUCTS_IN_SET.some((id) => id === productTypeId)
}

export function isValidProductsInSetCombination(productTypeIds: Array<number | null | undefined>): boolean {
    const uniqueProductTypeIds = new Set(productTypeIds.filter((id): id is number => id != null))
    const containsProductInSet = [...uniqueProductTypeIds].some((id) => isProductInSet(id))

    return !containsProductInSet || uniqueProductTypeIds.size === 1
}
